import {combineReducers} from 'redux'
import locationReducer from './location'
import {loginFormReducer, loginTokenReducer, userDataReducer, nowaitFlagReducer} from './login'
import {categoryReducer, categoryNameReducer} from './category'
import {registerFormReducer} from './register'
import {messageBarReducer} from './messageBar'
import {forgotFormReducer} from './forgotPassword'
import {cartItemsReducer} from './cartItems'
import {charityWindowReducer, charityInfoWindowReducer, askForCharityWindowReducer } from './charity'
import {generalLoaderReducer} from './generalLoader'
import {searchTextReducer, leftSidebarReducer} from './search'
import {walletItemsReducer} from './walletItems'
import {filterCitiesReducer, filterRegionsReducer, searchFilterCityReducer, searchFilterRegionReducer} from "./filters";
import { geopositionReducer } from './geoposition'
import { dealForGiftReducer, giftingWindowReducer, giftReducer, pastRecipientsReducer } from './gifting'
import { locationGroupWindowReducer } from './locationGroup'

export const makeRootReducer = (asyncReducers) => {
    return combineReducers({
        location: locationReducer,
        login: loginFormReducer,
        register: registerFormReducer,
        forgotPasswordForm: forgotFormReducer,
        token: loginTokenReducer,
        categories: categoryReducer,
        message: messageBarReducer,
        cartItemsQty: cartItemsReducer,
        charityWindow: charityWindowReducer,
        askForCharityWindow: askForCharityWindowReducer,
        charityInfoWindow: charityInfoWindowReducer,
        progressVisible: generalLoaderReducer,
        search: searchTextReducer,
        leftSidebarShow: leftSidebarReducer,
        walletItemsQty: walletItemsReducer,
        filterRegions: filterRegionsReducer,
        filterCities: filterCitiesReducer,
        me: userDataReducer,
        noWaitFlag: nowaitFlagReducer,
        searchCityParams: searchFilterCityReducer,
        searchRegionParams: searchFilterRegionReducer,
        categoryName: categoryNameReducer,
        geoposition: geopositionReducer,
        isGiftingModalVisible: giftingWindowReducer,
        addressBook: pastRecipientsReducer,
        gifts: giftReducer,
        dealForGift: dealForGiftReducer,
        locationGroup: locationGroupWindowReducer,
        ...asyncReducers
    })
}

export const injectReducer = (store, {key, reducer}) => {
    if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

    store.asyncReducers[key] = reducer
    store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js